import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'About Us', path: '/about' },
  { label: 'Services', path: '/services' },
  { label: 'Why Dr. Villarreal', path: '/why-dr-villarreal' },
  { label: 'Blog', path: '/blog' },
  { label: 'FAQ', path: '/faq' },
  { label: 'Contact', path: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0d0d0d]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        {/* Logo — co-branded with ACHC Certified Consultant logo per brand guidelines */}
        <Link to="/" className="flex items-center gap-4 cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/a0e0e895-3f57-4fcf-89e3-e09f29edb039.png"
            alt="Advantixx Logo"
            className="h-10 w-auto object-contain"
          />
          {/* Divider */}
          <span className="w-px h-8 bg-[#d4af37]/30 hidden sm:block"></span>
          {/* ACHC Certified Consultant Logo — co-branded per ACHC brand guidelines */}
          <a
            href="https://www.achc.org/certified-consultants.html"
            target="_blank"
            rel="nofollow noreferrer"
            onClick={(e) => e.stopPropagation()}
            className="hidden sm:block cursor-pointer"
            title="ACHC Certified Consultant"
          >
            <img
              src="https://storage.readdy-site.link/project_files/08c9742b-b998-4dd6-add2-07c3775679f4/3bc5c37e-5171-4cc8-96c1-cd12362a392c_ACHC-Certified-Consultant.png?v=6711ad00855061fc6dd29608e2540a8b"
              alt="ACHC Certified Consultant"
              className="h-10 w-auto object-contain"
            />
          </a>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium tracking-wide transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === link.path
                  ? 'text-[#d4af37]'
                  : 'text-[#c0c0c0] hover:text-[#d4af37]'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* CTA */}
        <div className="hidden md:flex items-center">
          <Link
            to="/services"
            className="whitespace-nowrap bg-[#d4af37] text-[#0d0d0d] text-sm font-bold px-6 py-2.5 rounded-full hover:bg-[#f4c430] transition-colors duration-200 cursor-pointer"
          >
            Book Consultation
          </Link>
        </div>

        {/* Hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center text-[#d4af37] cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0d0d0d]/98 backdrop-blur-md border-t border-[#d4af37]/20 px-6 py-6 flex flex-col gap-5">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-base font-medium cursor-pointer ${
                location.pathname === link.path ? 'text-[#d4af37]' : 'text-[#c0c0c0]'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/services"
            className="whitespace-nowrap bg-[#d4af37] text-[#0d0d0d] text-sm font-bold px-6 py-3 rounded-full text-center cursor-pointer"
          >
            Book Consultation
          </Link>
        </div>
      )}
    </nav>
  );
}
